import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { formatPeriod, getTargetPeriod } from '../../utils/periodUtils';

export default function ActivityDocumentButton({
  documentId,
  returnTo,
}: {
  documentId: string;
  returnTo?: string;
}) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const open = async () => {
    setLoading(true);
    setError(false);
    try {
      const { data, error: queryError } = await supabase
        .from('documents')
        .select(
          `
        id, applicable_month, applicable_year, upload_date,
        user_document_requirements!documents_requirement_id_fkey(
          user_id, due_date, document_definitions(renewal_type, renewal_interval)
        )
      `,
        )
        .eq('id', documentId)
        .single();
      const requirement = data?.user_document_requirements;
      if (queryError || !data || !requirement?.user_id)
        throw new Error('Documento no disponible');
      const { month, year } = getTargetPeriod({
        applicableMonth: data.applicable_month,
        applicableYear: data.applicable_year,
        uploadDate: data.upload_date,
        dueDate: requirement.due_date,
        renewalType: requirement.document_definitions?.renewal_type,
        renewalInterval: requirement.document_definitions?.renewal_interval as
          | string
          | null,
      });
      navigate(
        `/review/${encodeURIComponent(requirement.user_id)}?${new URLSearchParams(
          {
            ...(returnTo ? { returnTo } : {}),
            selectedMonth: formatPeriod(month, year),
            documentId,
          },
        )}`,
      );
    } catch {
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="mt-2">
      <button
        onClick={open}
        disabled={loading}
        className="text-sm font-medium text-blue-700 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-600 disabled:opacity-50"
      >
        {loading ? 'Abriendo…' : 'Abrir documento'}
      </button>
      {error && (
        <p role="alert" className="mt-1 text-xs text-red-800">
          No se pudo abrir el documento. Intenta de nuevo.
        </p>
      )}
    </div>
  );
}
